module.exports = __webpack_public_path__ + "img/7.8ff931e4.png";